import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { GradientDefs } from "@/components/site/GradientDefs";
import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";        // eslint-disable-line no-unused-vars
import HowItWorks from "@/pages/HowItWorks";
import Reports from "@/pages/Reports";
import Security from "@/pages/Security";
import About from "@/pages/About";
import ForTrades from "@/pages/ForTrades";
import IndustryPage from "@/pages/IndustryPage";
import ForIndex from "@/pages/ForIndex";
import Welcome from "@/pages/Welcome";        // eslint-disable-line no-unused-vars
import Billing from "@/pages/Billing";        // eslint-disable-line no-unused-vars
import Apply from "@/pages/Apply";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminOutreach from "@/pages/AdminOutreach";

// Scroll to top on route changes (but keep hash anchors working)
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <GradientDefs />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/apply" element={<Apply />} />
        {/* Pricing/checkout/welcome/billing are stalled while we run demo-first.
            Code is kept; route redirects to /apply. */}
        <Route path="/pricing" element={<Navigate to="/apply" replace />} />
        <Route path="/welcome" element={<Navigate to="/apply" replace />} />
        <Route path="/billing" element={<Navigate to="/apply" replace />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/security" element={<Security />} />
        <Route path="/about" element={<About />} />
        <Route path="/for" element={<ForIndex />} />
        <Route path="/for/trades" element={<ForTrades />} />
        <Route path="/for/:slug" element={<IndustryPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/outreach" element={<AdminOutreach />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
